export default __webpack_public_path__ + "static/media/FirstBase-2.af611097.jpg";